import { TranslationKeys } from '../english/auth.i18n';

export const keys: TranslationKeys = {
  auth: {
    loginForm: {
      title: 'Se connecter',
      email: 'Courriel',
      nextButton: 'Suivant',
    },
    passcodeForm: {
      title: 'Vérifiez votre boîte courriel...',
      desc: "Nous vous avons envoyé un code d'authentification unique au courriel {{0}}",
      label: "Code d'authentification",
      error: 'Le code entré est invalide ou expiré',
      resendButton: {
        cooldownLabel: 'Vous pourrez demander un nouveau code dans {{0}} secondes',
        readyLabel: 'Envoyez-moi un nouveau code',
      },
      helpLine1: 'Difficulté à vous connecter ?',
      helpLine2: 'Contactez-nous à <email>contact@youset.ca</email>',
    },
  },
};

export default keys;
